module.exports = "<app-breadcrum ></app-breadcrum>\r\n<router-outlet ></router-outlet>\r\n <app-footer></app-footer>\r\n"